import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LeatherBraToteBagBlack = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.accessories.LeatherBraToteBagBlack.itemName}
      name={AW23.accessories.LeatherBraToteBagBlack.itemName}
      price={AW23.accessories.LeatherBraToteBagBlack.itemPrice}
      fabric={AW23.accessories.LeatherBraToteBagBlack.itemFabric}
      src={AW23.accessories.LeatherBraToteBagBlack.sizeChart}
      divId={AW23.accessories.LeatherBraToteBagBlack.shopifyDivId}
      mainId={AW23.accessories.LeatherBraToteBagBlack.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.accessories.LeatherBraToteBagBlack.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.accessories.LeatherBraToteBagBlack.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LeatherBraToteBagBlack;
